module.exports = __webpack_public_path__ + "be9df26b33d63aaf8bdc4559f98b7f39.svg";